import { useState } from 'react';
import { Button } from '@/features/button';
import Drawer from '@/features/drawer';
import { useDrawer } from '@/features/drawer/context/use-drawer';
import { IconArrowDown, IconClose } from '@/features/icons';
import { AppButton } from '@/features/product-card/app-button';
import { EasyAccess } from '@/features/tag';
import CategoriesContent from './categories-content';
import { MOBILE_FILTER_DRAWER_NAME } from '../../constants';
import { useVideosFilterContext } from '../../context';
const MobileCategories = () => {
  const {
    activeCategories: submittedCategories,
    toggleCategory,
    clearCategories
  } = useVideosFilterContext();
  const [tempSelectedCategory, setTempSelectedCategory] = useState<number>();
  const {
    openDrawer,
    closeDrawer
  } = useDrawer();
  const handleOpenDrawer = () => {
    setTempSelectedCategory(submittedCategories.at(0)?.id?.value);
    openDrawer(MOBILE_FILTER_DRAWER_NAME);
  };
  const closeHandler = () => {
    closeDrawer(MOBILE_FILTER_DRAWER_NAME);
    setTempSelectedCategory(undefined);
  };
  const changeHandler = (value: number) => setTempSelectedCategory(prev => prev === value ? undefined : value);
  const submitChange = () => {
    if (tempSelectedCategory) {
      toggleCategory(tempSelectedCategory);
    } else {
      clearCategories();
    }
    setTempSelectedCategory(undefined);
    closeDrawer(MOBILE_FILTER_DRAWER_NAME);
  };
  const handleClearCategories = () => {
    clearCategories();
    setTempSelectedCategory(undefined);
    closeDrawer(MOBILE_FILTER_DRAWER_NAME);
  };
  const hasSubmittedCategory = !!submittedCategories.length;
  return <>
            <label onClick={handleOpenDrawer} className='flex cursor-pointer items-center gap-1 text-red-300 lg:hidden'>
                <EasyAccess size='medium' className='relative overflow-visible whitespace-nowrap' showClose={false} isActive={hasSubmittedCategory} data-sentry-element="EasyAccess" data-sentry-source-file="mobile.tsx">
                    <span className='ml-1'>دسته بندی</span>
                    <IconArrowDown className='h-4 w-4' data-sentry-element="IconArrowDown" data-sentry-source-file="mobile.tsx" />

                    {hasSubmittedCategory && <span className='absolute -top-1/4 left-1 h-3 w-3 rounded-full bg-primary-main text-center align-middle text-[7px] leading-3 text-white'>
                            {submittedCategories?.length}
                        </span>}
                </EasyAccess>
            </label>

            <Drawer position='bottom' name={MOBILE_FILTER_DRAWER_NAME} className='hide-scrollbar fixed bottom-12 h-[80dvh] w-full lg:bottom-0' withBackDrop data-sentry-element="Drawer" data-sentry-source-file="mobile.tsx">
                <div className='relative flex w-full items-center justify-center p-4 text-text-black shadow-sm'>
                    <span className='text-body-16 font-medium'>فیلترها</span>

                    <IconClose className='absolute left-4 h-6 w-6 cursor-pointer' onClick={closeHandler} data-sentry-element="IconClose" data-sentry-source-file="mobile.tsx" />
                </div>

                <div className='hide-scrollbar flex h-[calc(100dvh_-_133px)] grow flex-col gap-3 overflow-auto px-2 py-3'>
                    <CategoriesContent activeFilters={tempSelectedCategory ? [{
          id: {
            value: +tempSelectedCategory
          }
        }] : []} changeHandler={changeHandler} mode='mobile' data-sentry-element="CategoriesContent" data-sentry-source-file="mobile.tsx" />
                </div>

                <AppButton className='sticky bottom-0 right-0 grid grid-cols-2' isSingleButton data-sentry-element="AppButton" data-sentry-source-file="mobile.tsx">
                    <Button size='large' graphicStyle='filled' onClick={submitChange} data-sentry-element="Button" data-sentry-source-file="mobile.tsx">
                        اعمال
                    </Button>
                    <Button size='large' graphicStyle='outlined' onClick={handleClearCategories} disabled={!tempSelectedCategory} data-sentry-element="Button" data-sentry-source-file="mobile.tsx">
                        حذف فیلترها
                    </Button>
                </AppButton>
            </Drawer>
        </>;
};
export default MobileCategories;